import { render, staticRenderFns } from "./BVR.vue?vue&type=template&id=5924b440"
import script from "./BVR.vue?vue&type=script&lang=js"
export * from "./BVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports